<template>
	<div>
		<case-form class="mb6" :schema="schemaFromTo" />

		<j-expendable-box v-for="i in numberOfInsureds" :key="'Tour' + i" class="mt2">
			<div slot="header" class="xs-12 p4 fs4 fw7 bg5 r2 b1 bc7">Tour {{ i }}</div>
			<div slot="body" class="xs-12 p4 bg5 b1 bt0 bc7 r2">
				<case-form :schema="buildSchemaInsured(i - 1)" :isBoxed="false" />
			</div>
		</j-expendable-box>

		<!-- Add Button -->
		<j-button class="mt6" type="primary" @click="numberOfInsureds++">Add</j-button>
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"
import JButton from "@/components/JButton/"
import JExpendableBox from "@/components/JExpendableBox"

export default {
	name: "TOProposalInsureds",
	components: { CaseForm, JExpendableBox, JButton },

	data() {
		return {
			numberOfInsureds: this.$store?.state?.caseManagement?.case?.insureds
				?.length
				? this.$store.state.caseManagement.case.insureds.length
				: 1
		}
	},

	computed: {
		insureds() {
			return this.$store?.state?.caseManagement?.case?.insureds
		},

		schemaFromTo() {
			return [
				{
					label: "Leaving Country",
					component: "text",
					bindTo: "case.facts.leavingCountry"
				},
				{
					label: "Returning Country",
					component: "text",
					bindTo: "case.facts.returningCountry"
				},
				{
					label: "Name of Carrier",
					component: "text",
					bindTo: "case.facts.nameOfCarrier"
				}
			]
		},

		schemaInsureds() {
			let schema = []
			for (let i = 0; i < this.numberOfInsureds; i++) {
				schema.push(...this.buildSchemaInsured(i))
			}
			return schema
		}
	},

	methods: {
		buildSchemaInsured(i) {
			return [
				{
					label: "Select Tour " + (i + 1),
					component: "entitySelect",
					bindTo: `case.insureds[${i}]`,
					entity: `case.insureds[${i}]`,
					props: {
						allowedEntityTypes: ["object"]
					}
				},
				{
					label: "Tour Description",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.tourDescriptionInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "tourDescription"
						},
						createOptions: {
							type: "tourDescription",
							dataType: "string"
						}
					}
				},
				{
					label: "Tour Country",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.tourCountryInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "tourCountry"
						},
						createOptions: {
							type: "tourCountry",
							dataType: "string"
						}
					}
				},
				{
					label: "No of Days",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.noOfDaysInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "noOfDays"
						},
						createOptions: {
							type: "noOfDays",
							dataType: "number"
						}
					}
				},
				{
					label: "No of Trips",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.noOfTripsInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "noOfTrips"
						},
						createOptions: {
							type: "noOfTrips",
							dataType: "number"
						}
					}
				},
				{
					label: "Transit Type",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.transitTypeInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "transitType"
						},
						createOptions: {
							type: "transitType",
							dataType: "string",
							value: {
								component: "select",
								props: {
									options: [
										{ name: "Hong Kong", value: "Hong Kong" },
										{ name: "Hong Kong / Macau", value: "Hong Kong / Macau" },
										{ name: "Pacific Rim", value: "Pacific Rim" },
										{ name: "Rest of the world", value: "Rest of the world" },
										{ name: "USA & Canada", value: "USA & Canada" },
										{ name: "Worldwide", value: "Worldwide" }
									]
								}
							}
						}
					}
				}
			]
		}
	},

	watch: {
		insureds: {
			handler() {
				this.numberOfInsureds = this.$store?.state?.caseManagement?.case
					?.insureds?.length
					? this.$store?.state?.caseManagement?.case?.insureds?.length
					: 1
			}
		}
	}
}
</script>
